import HttpClientToken from '../../services/HttpClientToken';

import { defaultTipoNotificacion, TipoNotificacionProps } from '../../interfaces/catalogos/TipoNotificacionInterface';

export const TipoNotificaciones = () => {

    return new Promise<TipoNotificacionProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoNotificacion/', token)
            .then( ({ data } : { data : TipoNotificacionProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerTipoNotificacion = () => {

    return new Promise<TipoNotificacionProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoNotificacion/ObtenerTipoNotificaciones', token)
            .then( ({ data } : { data : TipoNotificacionProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarTipoNotificacion = ( params: TipoNotificacionProps ) => {

    return new Promise<TipoNotificacionProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoNotificacion/Actualizar', params, token)
            .then( ({ data } : { data : TipoNotificacionProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoNotificacion } );
            });

        }

    });

}

export const AgregarTipoNotificacion = ( params: TipoNotificacionProps ) => {

    return new Promise<TipoNotificacionProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoNotificacion/Agregar', params, token)
            .then( ({ data } : { data : TipoNotificacionProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoNotificacion } );
            });

        }

    });

}
